import Image from 'next/image';
import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import Tooltip from '@wetransfer/transfer/component/tooltip';
import I18n from '@wetransfer/transfer/modules/i18n';
import avatar from '@wetransfer/transfer/public/assets/images/placeholder/avatar.png';

import styles from './TransferInLockedRecipient.module.scss';

export interface TransferInLockedRecipientProps {
  channelName: string;
}

export const TransferInLockedRecipient = ({
  channelName,
}: TransferInLockedRecipientProps) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>
        {I18n.t('page.transfer_in.recipient_input_title')}
      </span>
      <span className={styles.recipient} title={channelName}>
        <span className={styles.recipient__logo}>
          <Image src={avatar} alt="logo" width="24" height="24" />
        </span>
        <span className={styles.recipient__name}>{channelName}</span>
      </span>
      <Tooltip
        trigger="hover"
        className={styles.tooltip}
        content={
          <>
            <p className={styles.tooltip__title}>
              {I18n.t('page.transfer_in.tooltip.title')}
            </p>
            <p className={styles.tooltip__text}>
              {I18n.t('page.transfer_in.tooltip.text', {
                name: channelName,
              })}
            </p>
          </>
        }
        offset={20}
        anchor="left"
      >
        <Icon type="InfoCircle" className={styles.icon} />
      </Tooltip>
    </div>
  );
};
